// src/context/AuthContext.js
import { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../services/api';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('sho_token');
    if (token) {
      api.me()
        .then(setUser)
        .catch(() => localStorage.removeItem('sho_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (email, password) => {
    const { token } = await api.login({ email, password });
    localStorage.setItem('sho_token', token);
    const me = await api.me();
    if (me.role !== 'STORE_OWNER') {
      localStorage.removeItem('sho_token');
      throw new Error('This portal is for store owners only.');
    }
    setUser(me);
    return me;
  };

  const register = async (data) => {
    const { token } = await api.register({ ...data, role: 'STORE_OWNER' });
    localStorage.setItem('sho_token', token);
    const me = await api.me();
    setUser(me);
    return me;
  };

  const logout = () => {
    localStorage.removeItem('sho_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
